import script from "./WalletWatchlistListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletWatchlistListItem.vue?vue&type=script&setup=true&lang=js"

import "./WalletWatchlistListItem.vue?vue&type=style&index=0&id=b3c24552&lang=css"

const __exports__ = script;

export default __exports__